module.exports = __webpack_public_path__ + "img/productHSE_22.81773cc6.png";